var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRightPanelCloser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-side-menu-right-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 40,
    height: 40,
    rx: 4,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_45_7",
    "data-name": "Component 45 \\u2013 7",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 24,
    height: 24,
    rx: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_9",
    className: "colorable",
    "data-name": "Union 9",
    d: "M0,16V0H6A2,2,0,0,1,8,2V14a2,2,0,0,1-2,2Zm6-2V2H2V14Z",
    transform: "translate(16 4)",
    fill: "rgba(0,0,0,0.87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_18",
    "data-name": "Subtraction 18",
    d: "M14,16H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H14V2H2V14H14v2Z",
    transform: "translate(0 4)",
    fill: "rgba(0,0,0,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-arrow-right-outline",
    d: "M19,21V19H15V17h4V15l3,3-3,3",
    transform: "translate(-8 -6)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRightPanelCloser);
export default __webpack_public_path__ + "static/media/icon-right-panel-closer.05142a7e342583babce9474caa30eee5.svg";
export { ForwardRef as ReactComponent };